// import courses from './courses.json'
export const subjects = ['English', 'Mathematics', 'History', 'Biology', 'Social Studies', 'Chemistry']
export const subCategories = ['Tech', 'Artisans', 'Education & Management', 'Arts', 'Food',]
export const categories = ['Tech', 'Artisans', 'Education & Management', 'Arts', 'Food',]
export const basic_schools = ['Basic 1', 'Basic 2','Basic 3','Basic 4','Basic 5','Basic 6', ]
export const secondary_schools = ['JSS 1', 'JSS 2','JS S 3','SS 1','SS 2','SS 3', ]
export const Prices = ['NGN 1,000 - NGN 20,000', 'NGN 21,000 - NGN 40,000','NGN 41,000 - NGN 60,000','NGN61,000 - NGN 99,000','NGN 100,0000' ]
export const courses = require('./courses.json')